module.exports = __webpack_public_path__ + "01969c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/17997.jpg
// module id = 1322
// module chunks = 0 1